import { useCallback, useMemo, useState } from 'react';
import { useUserContext } from 'src/contexts/UserContext';
import { NewOrderStatus } from 'src/entities/Order';
import { getOrderReviewWhatsappURL } from 'src/utils/whatsapp';
import ApproveModal from './ProductsDetailsActions/ApproveModal';

import { VENDORS_PORTAL_API_URL } from 'src/constants/urls';
import { ENABLE_ORDER_CANCELLATION } from 'src/modules/OrderManagement/utils/featureFlags';
import { Flex } from '@chakra-ui/react';

const ProductsDetailsActions = ({
  customer,
  orderNumber,
  orderStatus,
  orderUUID,
  fetchOrderDetail,
}) => {
  const { sendEvent } = useUserContext();

  const [openModal, setOpenModal] = useState(null);

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
  }, []);

  const handleOpenModal = useCallback(() => {
    setOpenModal(true);
  }, []);

  const orderReviewWhatsappURL = useMemo(
    () => getOrderReviewWhatsappURL(customer || ''),
    [customer],
  );

  const canApproveOrder = useMemo(
    () =>
      [NewOrderStatus.pending, NewOrderStatus.under_review].includes(
        orderStatus,
      ),
    [orderStatus],
  );

  const canCancelOrder = useMemo(
    () =>
      [
        NewOrderStatus.in_validation,
        NewOrderStatus.confirmed,
        NewOrderStatus.invoice_received,
        NewOrderStatus.pending,
        NewOrderStatus.under_review,
      ].includes(orderStatus),
    [orderStatus],
  );

  return (
    <>
      {ENABLE_ORDER_CANCELLATION ? (
        <Flex justifyContent="space-between" flexWrap="wrap">
          {canCancelOrder && (
            <a
              className="btn btn-deny border border-2 border-dark p-3"
              href={`${VENDORS_PORTAL_API_URL}/pedidos/detalhes/${orderUUID}/cancelamento`}
              onClick={() =>
                sendEvent('cancel_order_click', {
                  order_number: orderNumber,
                })
              }
            >
              Cancelar Pedido
            </a>
          )}

          {canApproveOrder && (
            <Flex flexWrap="wrap" justifySelf="flex-end">
              <a
                className="btn btn-deny border border-2 border-dark p-3 mt-3 mt-md-0"
                href={`${VENDORS_PORTAL_API_URL}/pedidos/detalhes/${orderUUID}/revisao`}
              >
                Editar itens do Pedido
              </a>

              <button
                className="btn btn-confirm p-3 ml-md-4 mt-3 mt-md-0"
                onClick={handleOpenModal}
              >
                Aprovar Pedido
              </button>
            </Flex>
          )}
        </Flex>
      ) : (
        <div className="row mb-4 d-flex justify-content-between">
          {canApproveOrder && (
            <>
              <div className="col-md-3 col-12">
                <button
                  className="btn btn-confirm p-3 "
                  onClick={handleOpenModal}
                >
                  Aprovar Pedido
                </button>
              </div>
              <div className="col-md-4 col-12 d-flex justify-content-end align-items-center">
                <p className="fw-light text-end m-0">
                  Não consegue atender ao pedido? Revise ele com suporte.
                </p>
              </div>
              <div className="col-md-3">
                <a
                  className="btn btn-deny ml-md-2 p-3 border border-2 border-dark"
                  href={`${VENDORS_PORTAL_API_URL}/pedidos/detalhes/${orderUUID}/revisao`}
                >
                  Revisar pedido
                </a>
              </div>
            </>
          )}

          <div className="col-md-auto col-12 mt-3 justify-content-end">
            <a
              rel="noreferrer"
              href={orderReviewWhatsappURL}
              target="_blank"
              className="btn btn-deny fw-normal border border-dark border-1 "
              onClick={() => sendEvent('order-faleconosco')}
            >
              Fale conosco
            </a>
          </div>
        </div>
      )}

      {openModal && (
        <ApproveModal
          closeModal={handleCloseModal}
          orderUUID={orderUUID}
          orderNumber={orderNumber}
          fetchOrderDetail={fetchOrderDetail}
        />
      )}
    </>
  );
};

export default ProductsDetailsActions;
